import { ProfilManagement } from '@repo/ui/features/profil/index';

export default function ProfilPage() {
  return <ProfilManagement />;
}
